<template>
  <section>
    <h4>Personagens Principais</h4>

    <p v-for="character in universe.characters" :key="character.slug">
      <router-link :to="`/${universe.slug}/${character.slug}`">{{
        character.name
      }}</router-link>
    </p>
  </section>
</template>

<script>
export default {
  name: 'characters-list',

  props: {
    universe: { type: Object, required: true },
  },
}
</script>
